const autoNgTemplateLoaderTemplate1 = require('./node-browser.html');

angular.module('portainer.docker').component('nodeBrowserView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'NodeBrowserController',
  bindings: {
    endpoint: '<',
  },
});
